// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
/* Store Custom Code
import {
    formFieldDescriptionWrapperStyles,
    formFieldInputSelectDisabledStyles,
    formFieldInputSelectIconStyles,
    formFieldLabelStyles,
    formFieldVariantStyles,
} from "@store/Themes/common/mixins/formField";
*/
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import {
    formFieldDescriptionWrapperStyles,
    formFieldInputSelectDisabledStyles,
    formFieldInputSelectIconStyles,
    formFieldLabelStyles,
    formFieldVariantStyles,
} from "@store/Themes/common/mixins/formField";
/* Store Custom Code - End */

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/FormField ------------------------------------ */
/* ------------------------------------------------------------------------------------------ */

const formField: Styleguide["formField"] = {
    defaultProps: {
        border: "rounded",
        backgroundColor: "common.background",
        labelProps: {
            css: formFieldLabelStyles(),
        },
        errorProps: {
            color: "danger",
            size: "inherit",
            weight: "normal", // Store Custom Code
        },
        hintProps: {
            color: "text.accent",
            size: "inherit",
            weight: "normal",
        },
        cssOverrides: {
            inputSelect: css`
                ${formFieldVariantStyles()}
                ${formFieldInputSelectIconStyles("primary", "primary.dark")}
                /* Store Custom Code - Start */
                ${formFieldInputSelectDisabledStyles("text.disabled", "common.disabledDark", "transparent")}
                /* Store Custom Code - End */
                color: ${getColor("text.input")};
                /* Store Custom Code - Start */
                transition: ${transitionHoverStyles("border-color")};
                &:not(:disabled):not(:focus):hover {
                    border-color: ${getColor("common.borderLight")};
                }
                /* Store Custom Code - End */
            `,
            descriptionWrapper: formFieldDescriptionWrapperStyles(),
        },
    },
};

export default formField;
